import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { representantesRoles } from './shared/listaRoles';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'redirect' },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'redirect' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmacion-requerida', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'password-olvidado', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes') }
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') },
            { path: 'redirect', loadChildren: () => import('app/shared/redirect/redirect.routes') },

        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes') },
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {
                path: 'procesos',
                loadChildren: () => import('app/modules/admin/admin-inicio/admin-inicio.routes'),
                canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA','REPRESENTANTE_CONTRALORIA'] } }
            },
            {
                path: 'nuevo-usuario', loadChildren: () => import('app/modules/admin/catalogo-usuarios/usuarioform/usuarioform.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA'] } }
            },
            {
                path: 'usuarios', loadChildren: () => import('app/modules/admin/catalogo-usuarios/tablausuario/tablausuario.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA'] } }
            },
            {
                path: 'representantes', loadChildren: () => import('app/modules/representantes/tabla-representantes/tabla-representantes.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA',...representantesRoles] } }
            },
            {
                path: 'capturista', loadChildren: () => import('app/modules/capturistas/tabla-capturistas/tabla-capturitas.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','CAPTURISTA'] } }
            },
            {
                path: 'usuario-detalle/:id', loadChildren: () => import('app/modules/admin/catalogo-usuarios/usuariodetalle/usuariodetalle.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA'] } }
            },
            {
                path: 'nueva-dependencia', loadChildren: () => import('app/modules/admin/dependencias/dependenciaform/dependenciaform.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA'] } }
            },
            {
                path: 'dependencias', loadChildren: () => import('app/modules/admin/dependencias/tabladependencias/tabladependencias.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA'] } }
            },
            {
                path: 'dependencia-detalle/:id', loadChildren: () => import('app/modules/admin/dependencias/dependenciadetalle/dependenciadetalle.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA'] } }
            },
            {
                path: 'formatos', loadChildren: () => import('app/modules/admin/formatos/tablaformatos/tablaformatos.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA'] } }
            },
            {
                path: 'nuevo-formato', loadChildren: () => import('app/modules/admin/formatos/formatoform/formatoform.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA'] } }
            },
            {
                path: 'formato-detalle/:id', loadChildren: () => import('app/modules/admin/formatos/formatodetalle/formatodetalle.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA'] } }
            },
            {
                path: 'proceso-detalle/:id', loadChildren: () => import('app/modules/admin/proceso/procesodetalle/procesodetalle.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA','REPRESENTANTE_CONTRALORIA'] } }
            },
            {
                path: 'proceso-detalle-formatos/:id', loadChildren: () => import('app/modules/admin/proceso/procesodetalleformatos/procesodetalleformatos.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA','REPRESENTANTE_CONTRALORIA'] } }
            },
            {
                path: 'proceso-form', loadChildren: () => import('app/modules/admin/proceso/procesoform/procesoform.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA','REPRESENTANTE_CONTRALORIA'] } }
            },
            {
                path: 'proceso-formatos/:id', loadChildren: () => import('app/modules/admin/proceso/procesoformatos/procesoformatos.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA','REPRESENTANTE_CONTRALORIA'] } }
            },
            {
                path: 'usuario-proceso-formatos/:id', loadChildren: () => import('app/modules/usuario/proceso/usuario-procesoformatos/usuario-procesoformatos.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','SERVIDOR_PUBLICO','COORDINADOR_CONTRALORIA'] } }
            },
            {
                path: 'dashboard-not', loadChildren: () => import('app/modules/admin/dashboards/project/project.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA','REPRESENTANTE_CONTRALORIA'] } }
            },
            {
                path: 'dashboard', loadChildren: () => import('app/modules/admin/dashboards/indicadores/indicadores.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA','REPRESENTANTE_CONTRALORIA','ANALITICA'] } }
            },
            {
                path: 'dashboard-dependencia', loadChildren: () => import('app/modules/admin/dashboards/indicadores-dependencia/indicadores-dependencia.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA','REPRESENTANTE_CONTRALORIA','ANALITICA'] } }
            },
            {
                path: 'tablero-formatos', loadChildren: () => import('app/modules/admin/dashboards/dependencias-avances/dependencias-avances.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA','REPRESENTANTE_CONTRALORIA','ANALITICA'] } }
            },
            {
                path: 'cierre', loadChildren: () => import('app/modules/cierre/cierreactawizard/cierreactawizard.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA','REPRESENTANTE_CONTRALORIA'] } }
            },
            {
                path: 'catalogo-capturista', loadChildren: () => import('app/modules/capturistas/asignacion-capturista/asignacion-capturistas.routes'), canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA'] } }
            }
        ]
    },
    // Usuario routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {
                path: 'usuario-inicio',
                loadChildren: () => import('app/modules/usuario/usuario-inicio/usuario-inicio.routes'),
                canActivate: [NgxPermissionsGuard],
                data: { permissions: { only: ['ROLE_ADMIN', 'SERVIDOR_PUBLICO','COORDINADOR_CONTRALORIA'] } }
            },
            {path: 'entrega-formato/OP001', loadChildren: () => import('app/modules/forms/OP001/OP001.routes')},
            {path: 'entrega-formato/OP002', loadChildren: () => import('app/modules/forms/OP002/OP002.routes')},
            {path: 'entrega-formato/OP003', loadChildren: () => import('app/modules/forms/OP003/OP003.routes')},
            {path: 'entrega-formato/DO001', loadChildren: () => import('app/modules/forms/DO001/DO001.routes')},
            {path: 'entrega-formato/OT001', loadChildren: () => import('app/modules/forms/OT001/OT001.routes')},
            {path: 'entrega-formato/OT002', loadChildren: () => import('app/modules/forms/OT002/OT002.routes')},
            {path: 'entrega-formato/OT003', loadChildren: () => import('app/modules/forms/OT003/OT003.routes')},
            {path: 'entrega-formato/OT004', loadChildren: () => import('app/modules/forms/OT004/OT004.routes')},
            {path: 'entrega-formato/OT005', loadChildren: () => import('app/modules/forms/OT005/OT005.routes')},
            {path: 'entrega-formato/OT006', loadChildren: () => import('app/modules/forms/OT006/OT006.routes')},
            {path: 'entrega-formato/OT007', loadChildren: () => import('app/modules/forms/OT007/OT007.routes')},
            {path: 'entrega-formato/OT008', loadChildren: () => import('app/modules/forms/OT008/OT008.routes')},
            {path: 'entrega-formato/OT009', loadChildren: () => import('app/modules/forms/OT009/OT009.routes')},
            {path: 'entrega-formato/OT010', loadChildren: () => import('app/modules/forms/OT010/OT010.routes')},
            {path: 'entrega-formato/DO002', loadChildren: () => import('app/modules/forms/DO002/DO002.routes')},
            {path: 'entrega-formato/DO003', loadChildren: () => import('app/modules/forms/DO003/DO003.routes')},
            {path: 'entrega-formato/DO004', loadChildren: () => import('app/modules/forms/DO004/DO004.routes')},
            {path: 'entrega-formato/RA001', loadChildren: () => import('app/modules/forms/RA001/RA001.routes')},
            {path: 'entrega-formato/RA002', loadChildren: () => import('app/modules/forms/RA002/RA002.routes')},
            {path: 'entrega-formato/RA003', loadChildren: () => import('app/modules/forms/RA003/RA003.routes')},
            {path: 'entrega-formato/RA004', loadChildren: () => import('app/modules/forms/RA004/RA004.routes')},
            {path: 'entrega-formato/RA005', loadChildren: () => import('app/modules/forms/RA005/RA005.routes')},
            {path: 'entrega-formato/RA006', loadChildren: () => import('app/modules/forms/RA006/RA006.routes')},
            {path: 'entrega-formato/RA007', loadChildren: () => import('app/modules/forms/RA007/RA007.routes')},
            {path: 'entrega-formato/MJ001', loadChildren: () => import('app/modules/forms/MJ001/MJ001.routes')},
            {path: 'entrega-formato/MJ002', loadChildren: () => import('app/modules/forms/MJ002/MJ002.routes')},
            {path: 'entrega-formato/RH001', loadChildren: () => import('app/modules/forms/RH001/RH001.routes')},
            {path: 'entrega-formato/RH002', loadChildren: () => import('app/modules/forms/RH002a/RH002a.routes')},
            {path: 'entrega-formato/RH003', loadChildren: () => import('app/modules/forms/RH003/RH003.routes')},
            {path: 'entrega-formato/RH004', loadChildren: () => import('app/modules/forms/RH004/RH004.routes')},
            {path: 'entrega-formato/RH005', loadChildren: () => import('app/modules/forms/RH005/RH005.routes')},
            {path: 'entrega-formato/RH006', loadChildren: () => import('app/modules/forms/RH006/RH006.routes')},
            {path: 'entrega-formato/RH007', loadChildren: () => import('app/modules/forms/RH007/RH007.routes')},
            {path: 'entrega-formato/RH008', loadChildren: () => import('app/modules/forms/RH008/RH008.routes')},
            {path: 'entrega-formato/RH009', loadChildren: () => import('app/modules/forms/RH009/RH009.routes')},
            {path: 'entrega-formato/RM001', loadChildren: () => import('app/modules/forms/RM001/RM001.routes')},
            {path: 'entrega-formato/RM002', loadChildren: () => import('app/modules/forms/RM002/RM002.routes')},
            {path: 'entrega-formato/RM003', loadChildren: () => import('app/modules/forms/RM003/RM003.routes')},
            {path: 'entrega-formato/RM004', loadChildren: () => import('app/modules/forms/RM004/RM004.routes')},
            {path: 'entrega-formato/RM005', loadChildren: () => import('app/modules/forms/RM005/RM005.routes')},
            {path: 'entrega-formato/RM006', loadChildren: () => import('app/modules/forms/RM006/RM006.routes')},
            {path: 'entrega-formato/RM007', loadChildren: () => import('app/modules/forms/RM007/RM007.routes')},
            {path: 'entrega-formato/RM008', loadChildren: () => import('app/modules/forms/RM008/RM008.routes')},
            {path: 'entrega-formato/RF001', loadChildren: () => import('app/modules/forms/RF001/RF001.routes')},
            {path: 'entrega-formato/RF002', loadChildren: () => import('app/modules/forms/RF002/RF002.routes')},
            {path: 'entrega-formato/RF003', loadChildren: () => import('app/modules/forms/RF003/RF003.routes')},
            {path: 'entrega-formato/RF004', loadChildren: () => import('app/modules/forms/RF004/RF004.routes')},
            {path: 'entrega-formato/RF005', loadChildren: () => import('app/modules/forms/RF005/RF005.routes')},
            {path: 'entrega-formato/RF006', loadChildren: () => import('app/modules/forms/RF006/RF006.routes')},
            {path: 'entrega-formato/RF007', loadChildren: () => import('app/modules/forms/RF007/RF007.routes')},
            {path: 'entrega-formato/RF008', loadChildren: () => import('app/modules/forms/RF008/RF008.routes')},
            {path: 'entrega-formato/RF009', loadChildren: () => import('app/modules/forms/RF009/RF009.routes')},
            {path: 'entrega-formato/RF010', loadChildren: () => import('app/modules/forms/RF010/RF010.routes')},
            {path: 'entrega-formato/RF011', loadChildren: () => import('app/modules/forms/RF011/RF011.routes')},
            {path: 'entrega-formato/RF012', loadChildren: () => import('app/modules/forms/RF012/RF012.routes')},
            {path: 'entrega-formato/RF013', loadChildren: () => import('app/modules/forms/RF013/RF013.routes')},
            {path: 'entrega-formato/EO001', loadChildren: () => import('app/modules/forms/EO001/EO001.routes')},
            {path: 'entrega-formato/RM001DMAYF', loadChildren: () => import('app/modules/forms/RM001DMAYF/RM001DMAYF.routes')},
            {path: 'entrega-formato/RM002DMAYF', loadChildren: () => import('app/modules/forms/RM002DMAYF/RM002DMAYF.routes')},
            {path: 'entrega-formato/RM003DMAYF', loadChildren: () => import('app/modules/forms/RM003DMAYF/RM003DMAYF.routes')},
            {path: 'entrega-formato/RM004DMAYF', loadChildren: () => import('app/modules/forms/RM004DMAYF/RM004DMAYF.routes')},
            {path: 'entrega-formato/RM005DMAYF', loadChildren: () => import('app/modules/forms/RM005DMAYF/RM005DMAYF.routes')},
            {path: 'entrega-formato/RH001DMAYF', loadChildren: () => import('app/modules/forms/RH001DMAYF/RH001DMAYF.routes')},
            {path: 'entrega-formato/RH002DMAYF', loadChildren: () => import('app/modules/forms/RH002DMAYF/RH002DMAYF.routes')},
            {path: 'entrega-formato/RH003DMAYF', loadChildren: () => import('app/modules/forms/RH003DMAYF/RH003DMAYF.routes')},
            {path: 'entrega-formato/EO001DMAYF', loadChildren: () => import('app/modules/forms/EO001DMAYF/EO001DMAYF.routes')},
        ]
    },
    { path: '**', loadChildren: () => import('app/modules/error/error-404/error-404.module').then(m => m.Error404Module) }
];
